<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div *ngIf="hasCompanyDetailsViewPermission" class="card-header modal-card-header">
      <h4 class="card-title" id="basic-layout-form">{{ 'company.title' | translate }}</h4>
      <p class="mb-0">{{ 'company.text' | translate: currentObject }}</p>
    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-2'">
        <form class="form" #companyForm="ngForm" (ngSubmit)="onSubmit(companyForm)">
          <div class="form-body">
            <ul ngbNav #nav="ngbNav" class="nav-tabs">

              <!-- Company -->
              <li *ngIf="hasCompanyDetailsViewPermission" ngbNavItem>
                <a #companyDetailsLink ngbNavLink>
                  <i class="ft-home"></i> {{ 'company.title' | translate }} </a>
                <ng-template ngbNavContent>

                  <h4 class="form-section">
                    <i class="ft-cpu"></i> {{ 'company.detailsHeader' | translate }}
                  </h4>

                  <!-- CompanyId -->
                  <div class="form-group">
                    <label for="CompanyId">{{ 'company.companyIdFieldLabel' | translate }}</label>
                    <input class="form-control" name="CompanyId" #CompanyId="ngModel"
                           [(ngModel)]="currentObject.CompanyId"
                           placeholder="{{'company.companyIdFieldPlaceHolder' | translate}}"
                           readonly="readonly">
                  </div>

                  <!-- Name -->
                  <div class="form-group">
                    <label for="Name">{{ 'company.nameFieldLabel' | translate }}</label>
                    <input
                      class="form-control"
                      required
                      name="Name"
                      #Name="ngModel"
                      [(ngModel)]="currentObject.Name"
                      (ngModelChange)="onNameChange()"
                      placeholder="{{'company.nameFieldPlaceHolder' | translate}}">
                  </div>

                  <!-- Slug -->
                  <div class="form-group">
                    <label for="Slug">{{ 'company.slugFieldLabel' | translate }}</label>
                    <input
                      class="form-control"
                      name="Slug"
                      #Slug="ngModel"
                      [(ngModel)]="currentObject.Slug"
                      (ngModelChange)="onSlugChange($event)"
                      maxlength="45"
                      placeholder="{{currentObject.SlugSuggestion ? currentObject.SlugSuggestion : 'company.slugFieldPlaceHolder' | translate}}"
                      pattern="^[a-z0-9\-]{1,45}$">
                    <small class="text-danger d-block" *ngIf="slugIsNotUnique">
                      <i class="ft-alert-circle"></i> {{ 'company.slugNotUniqueMessage' | translate }}
                    </small>
                    <small class="text-warning" *ngIf="slugChangedFromPersistedValue">
                      <i class="ft-alert-triangle"></i> {{ 'company.slugChangedWarningMessage' | translate }}
                    </small>
                  </div>

                  <!-- Address -->
                  <div class="form-group">
                    <label for="Address">{{ 'company.addressFieldLabel' | translate }}</label>
                    <input class="form-control" required name="Address" #Address="ngModel"
                           [(ngModel)]="currentObject.Address"
                           placeholder="{{'company.addressFieldPlaceHolder' | translate}}">
                  </div>

                  <!-- PostalCode -->
                  <div class="form-group">
                    <label for="PostalCode">{{ 'company.postalCodeFieldLabel' | translate }}</label>
                    <input class="form-control" required name="PostalCode" #PostalCode="ngModel"
                           [(ngModel)]="currentObject.PostalCode"
                           placeholder="{{'company.postalCodeFieldPlaceHolder' | translate}}">
                  </div>

                  <!-- City -->
                  <div class="form-group">
                    <label for="City">{{ 'company.cityFieldLabel' | translate }}</label>
                    <input class="form-control" required name="City" #City="ngModel" [(ngModel)]="currentObject.City"
                           placeholder="{{'company.cityFieldPlaceHolder' | translate}}">
                  </div>

                  <!-- IBAN -->
                  <div class="form-group">
                    <label for="IBAN">{{ 'company.iBANFieldLabel' | translate }}</label>
                    <input class="form-control" required name="IBAN" #IBAN="ngModel" [(ngModel)]="currentObject.IBAN"
                           placeholder="{{'company.iBANFieldPlaceHolder' | translate}}">
                  </div>

                  <!-- Payment Request number of days validity -->
                  <app-number-of-days-selection-list
                    [(selectedObjectId)]="currentObject.PaymentRequestNumberOfDaysValid"
                    [labelText]="'company.selectPaymentRequestNumberOfDaysValidLabelText' | translate"
                    [selectObjectText]="'company.selectPaymentRequestNumberOfDaysValidPlaceHolder' | translate"
                    (selectedObjectChangedEvent)="handleNumberOfDaysChanged($event)"></app-number-of-days-selection-list>

                  <!-- Payment Request default return/redirect url -->
                  <div class="form-group">
                    <label
                      for="DefaultReturnUrl">{{ 'company.paymentRequestDefaultReturnUrlLabel' | translate }}</label>
                    <input class="form-control" name="DefaultReturnUrl" #DefaultReturnUrl="ngModel"
                           [(ngModel)]="currentObject.PaymentRequestDefaultReturnUrl"
                           placeholder="{{'company.paymentRequestDefaultReturnUrlFieldPlaceHolder' | translate}}">
                  </div>

                  <!-- RPA -->
                  <div>
                    <h4 class="form-section form-row">
                      <div class="col-md-2">
                        <i class="ft-cpu"></i> {{ 'company.rpaHeader' | translate }}
                      </div>
                    </h4>
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckIsRPAClient" name="flexSwitchCheckIsRPAClient" [(ngModel)]="currentObject.IsUsingRPA">
                        <label class="form-check-label" for="flexSwitchCheckIsRPAClient">{{ 'company.isUsingRPAFieldLabel' | translate }} <i class="ft-info" [ngbTooltip]="'company.isUsingRPAFieldTooltip' | translate"></i></label>
                      </div>
                    </div>
                  </div>

                  <h4 class="form-section">
                    <i class="ft-edit"></i>{{ 'company.exactOnlineHeader' | translate }}
                  </h4>

                  <!-- Account Selection -->
                  <app-customer-organization-selection-list [(selectedObjectId)]="currentObject.ExactAccountId"
                                                            [labelText]="'company.exactAccountFieldLabel' | translate"
                                                            [selectObjectText]="'company.exactAccountFieldPlaceHolder' | translate"
                                                            (selectedObjectChangedEvent)="this.handleCustomerOrganizationChanged($event)"></app-customer-organization-selection-list>
                  <div class="form-group">
                    <input type="hidden" class="form-control" name="ExactAccountId" id="ExactAccountId" #ExactAccountId="ngModel"
                           [(ngModel)]="currentObject.ExactAccountId" [required]="currentObject.AllowAutoCreditUpdates">
                  </div>

                  <!-- Purchase order number -->
                  <div class="form-group row">
                    <div class="col-md-4">
                      <label for="PurchaseOrderNumber">{{ 'company.purchaseOrderNumberFieldLabel' | translate }} <i class="ft-info" [ngbTooltip]="'company.purchaseOrderNumberFieldTooltip' | translate"></i></label>
                      <input class="form-control company-input" type="text" maxlength="30"
                             name="PurchaseOrderNumber" id="PurchaseOrderNumber" #PurchaseOrderNumber="ngModel"
                             [(ngModel)]="currentObject.PurchaseOrderNumber"
                             [placeholder]="'company.purchaseOrderNumberFieldPlaceHolder' | translate">
                    </div>
                  </div>


                  <!-- Credit -->
                  <div>
                    <h4 class="form-section form-row">
                      <div class="col-md-2">
                        <i class="icon-credit-card"></i> {{ 'company.creditHeader' | translate }}
                      </div>
                    </h4>
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="flexSwitchCheckAutoCreditUpdates" name="flexSwitchCheckAutoCreditUpdates" [(ngModel)]="currentObject.AllowAutoCreditUpdates">
                        <label class="form-check-label" for="flexSwitchCheckAutoCreditUpdates">{{ 'company.allowAutoCreditUpdateFieldLabel' | translate }} <i class="ft-info" [ngbTooltip]="'company.allowAutoCreditUpdateFieldTooltip' | translate"></i></label>
                      </div>
                    </div>

                    <!-- Credit Amount -->
                    <div class="form-group row" *ngIf="currentObject.CompanyId">
                      <div class="col-md-4">
                        <label for="CreditAmount">{{ 'company.creditAmountFieldLabel' | translate }}</label>
                        <input class="form-control company-input" placeholder="" name="CreditAmount"
                               #CreditAmount="ngModel" [(ngModel)]="currentObject.CreditAmountCurrency" required
                               readonly="readonly">
                      </div>

                    </div>

                    <!-- Automatic Credit Updates -->
                    <div class="form-group row" *ngIf="currentObject.AllowAutoCreditUpdates">
                      <!-- Credit Update Amount -->
                      <div class="col">
                        <label for="CreditUpdateAmount">{{ 'company.autoCreditUpdateAmountFieldLabel' | translate }}</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                          </div>
                          <input type="number" [appMinValue]="50" [min]="50" [step]="5.0" class="form-control company-input" placeholder="" name="CreditUpdateAmount"
                                 id="CreditUpdateAmount" #CreditUpdateAmount="ngModel" [(ngModel)]="currentObject.AutoCreditUpdateAmount" [required]="currentObject.AllowAutoCreditUpdates">
                        </div>
                        <div *ngIf="CreditUpdateAmount.errors?.appMinValue" class="text-danger small mt-1">
                          {{ 'company.autoCreditUpdateAmountMinimumMessage' | translate:{ minimum: CreditUpdateAmount.errors.appMinValue.min } }}
                        </div>
                      </div>

                      <!-- Credit Update Threshold -->
                      <div class="col">
                        <label for="CreditUpdateThreshold">{{ 'company.autoCreditUpdateThresholdFieldLabel' | translate }} <i class="ft-info" [ngbTooltip]="'company.autoCreditUpdateThresholdFieldTooltip' | translate"></i></label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                          </div>
                          <input type="number" [appMinValue]="25" [min]="25" [step]="1.0" class="form-control company-input" placeholder="" name="CreditUpdateThreshold"
                                 id="CreditUpdateThreshold" #CreditUpdateThreshold="ngModel" [(ngModel)]="currentObject.AutoCreditUpdateThreshold" [required]="currentObject.AllowAutoCreditUpdates">
                        </div>
                        <div *ngIf="CreditUpdateThreshold.errors?.appMinValue" class="text-danger small mt-1">
                          {{ 'company.autoCreditUpdateThresholdMinimumMessage' | translate:{ minimum: CreditUpdateThreshold.errors.appMinValue.min } }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Onboarding IbanXS-->
                  <div *ngIf="currentObject.CompanyId">
                    <h4 class="form-section">
                      <i class="ft-share-2"></i> {{ 'company.onboardingIbanXSHeader' | translate }}
                    </h4>

                    <!-- Onboarding Form Type -->
                    <div class="form-group">
                      <label>{{ 'company.onboardingFormTypeHeader' | translate }}</label>

                      <!-- Company -->
                      <div class="form-check">
                        <input type="radio" required class="form-check-input" id="OnboardingFormCompany," [value]="0"
                               name="IbanXSOnboardingFormCode" [(ngModel)]="currentObject.IbanXSOnboardingFormCode">
                        <label class="form-check-label"
                               for="OnboardingFormCompany,">{{ 'company.onboardingFormCompanyFieldLabel' | translate }}</label>
                      </div>
                      <!-- Foundation-->
                      <div class="form-check">
                        <input type="radio" class="form-check-input" id="OnboardingFormFoundation" [value]="1"
                               name="IbanXSOnboardingFormCode" [(ngModel)]="currentObject.IbanXSOnboardingFormCode">
                        <label class="form-check-label"
                               for="OnboardingFormFoundation">{{ 'company.onboardingFormFoundationFieldLabel' | translate }}</label>
                      </div>
                      <!-- Freelance -->
                      <div class="form-check">
                        <input type="radio" class="form-check-input" id="OnboardingFormFreelance" [value]="2"
                               name="IbanXSOnboardingFormCode" [(ngModel)]="currentObject.IbanXSOnboardingFormCode">
                        <label class="form-check-label"
                               for="OnboardingFormFreelance">{{ 'company.onboardingFormFreelanceFieldLabel' | translate }}</label>
                      </div>
                      <!-- Private Person -->
                      <div class="form-check">
                        <input type="radio" class="form-check-input" id="OnboardingFormPrivatePerson" [value]="3"
                               name="IbanXSOnboardingFormCode" [(ngModel)]="currentObject.IbanXSOnboardingFormCode">
                        <label class="form-check-label"
                               for="OnboardingFormPrivatePerson">{{ 'company.onboardingFormPrivatePersonFieldLabel' | translate }}</label>
                      </div>
                    </div>

                    <div class="row">
                      <button [hidden]="openOnboardingUrlButtonDisabled" type="button"
                              class="btn btn-raised btn-raised btn-warning ml-2" (click)="openOnboardingUrl(i)">
                        <i class="ft-link"></i> {{ 'buttons.openUrl' | translate }}
                      </button>
                      <button [hidden]="startIbanXSOnboardingButtonDisabled" type="button"
                              class="btn btn-primary btn-raised ml-2" (click)="startIbanXSOnboarding()">
                        <i class="icon-key"></i> {{ 'buttons.generateUrl' | translate }}
                      </button>

                      <!-- Status -->
                      <div class="card-field col-auto ml-2">
                        <div class="card-field-content mt-1"><i [ngClass]="currentObject.OnboardingStatus.IconClass"
                                                                title="{{currentObject.OnboardingStatus.Hint}}"></i>
                        </div>
                      </div>

                      <!-- Status Hint -->
                      <div class="card-field col-auto">
                        <div class="card-field-content">{{ currentObject.OnboardingStatus.Hint }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- Module Selection -->
                  <app-module-selection #ModuleSelection
                                        [title]="'company.modules.title' | translate"
                                        [transactionFeeFieldLabel]="'company.modules.transactionFeeFieldLabel' | translate"
                                        [refundCostFieldLabel]="'company.modules.refundCostFieldLabel' | translate"
                                        [noModulesAvailableMessage]="'company.modules.noModulesAvailableMessage' | translate"
                                        sourceUrl="/module/company" displayTransactionFee="true"
                                        [(companyId)]="currentObject.CompanyId">
                  </app-module-selection>

                  <div class="form-body">

                    <!-- Page Styling -->
                    <div class="form-group">
                      <h4 class="form-section">
                        <i class="ft-edit"></i> {{ 'company.pageStylingHeader' | translate }}
                      </h4>

                      <!-- Html -->
                      <div class="form-group">
                        <label for="WelcomeText">{{ 'company.htmlFieldLabel' | translate }}</label>
                        <textarea class="form-control" name="Html" #Html="ngModel" [(ngModel)]="currentPageStyle.Html"
                                  placeholder="{{'company.htmlFieldPlaceHolder' | translate}}" rows="5"></textarea>
                      </div>

                      <!-- Css -->
                      <div class="form-group">
                        <label for="WelcomeText">{{ 'company.cssFieldLabel' | translate }}</label>
                        <textarea class="form-control" name="Css" #Css="ngModel" [(ngModel)]="currentPageStyle.Css"
                                  placeholder="{{'company.cssFieldPlaceHolder' | translate}}" rows="5"></textarea>
                      </div>

                      <!-- AIHubPaymentRequestHtml -->
                      <div class="form-group">
                        <label for="AIHubPaymentRequestHtml">AI-Hub betaalverzoek HTML</label>
                        <textarea class="form-control" name="AIHubPaymentRequestHtml" #AIHubPaymentRequestHtml="ngModel"
                                  [(ngModel)]="currentPageStyle.AIHubPaymentRequestHtml"
                                  placeholder="AI-Hub hosted betaalverzoek HTML template"
                                  rows="5"></textarea>
                      </div>

                      <!-- AIHubPaymentRequestCss -->
                      <div class="form-group">
                        <label for="AIHubPaymentRequestCss">AI-Hub betaalverzoek CSS</label>
                        <textarea class="form-control" name="AIHubPaymentRequestCss" #AIHubPaymentRequestCss="ngModel"
                                  [(ngModel)]="currentPageStyle.AIHubPaymentRequestCss"
                                  placeholder="AI-Hub hosted betaalverzoek CSS"
                                  rows="5"></textarea>
                      </div>

                      <!-- WelcomeText -->
                      <div class="form-group">
                        <label for="WelcomeText">{{ 'company.welcomeTextFieldLabel' | translate }}</label>
                        <textarea class="form-control" name="WelcomeText" #WelcomeText="ngModel"
                                  [(ngModel)]="currentPageStyle.WelcomeText"
                                  placeholder="{{'company.welcomeTextFieldPlaceHolder' | translate}}"
                                  rows="3"></textarea>
                      </div>

                      <!-- HeaderColor -->
                      <div class="form-group">
                        <label for="HeaderColor">{{ 'company.headerColorFieldLabel' | translate }}</label>
                        <input class="form-control" name="HeaderColor" #HeaderColor="ngModel"
                               [(ngModel)]="currentPageStyle.HeaderColor"
                               placeholder="{{'company.headerColorFieldPlaceHolder' | translate}}">
                      </div>

                      <!-- HeadingTextColor -->
                      <div class="form-group">
                        <label for="HeadingTextColor">{{ 'company.headingTextColorFieldLabel' | translate }}</label>
                        <input class="form-control" name="HeadingTextColor" #HeadingTextColor="ngModel"
                               [(ngModel)]="currentPageStyle.HeadingTextColor"
                               placeholder="{{'company.headingTextColorFieldPlaceHolder' | translate}}">
                      </div>

                      <!-- BodyTextColor -->
                      <div class="form-group">
                        <label for="BodyTextColor">{{ 'company.bodyTextColorFieldLabel' | translate }}</label>
                        <input class="form-control" name="BodyTextColor" #TextColor="ngModel"
                               [(ngModel)]="currentPageStyle.BodyTextColor"
                               placeholder="{{'company.bodyTextColorFieldPlaceHolder' | translate}}">
                      </div>

                      <!-- ButtonColor -->
                      <div class="form-group">
                        <label for="ButtonColor">{{ 'company.buttonColorFieldLabel' | translate }}</label>
                        <input class="form-control" name="ButtonColor" #ButtonColor="ngModel"
                               [(ngModel)]="currentPageStyle.ButtonColor"
                               placeholder="{{'company.buttonColorFieldPlaceHolder' | translate}}">
                      </div>

                      <!-- PaymentActionPageCss -->
                      <div class="form-group">
                        <label for="PaymentActionPageCss">{{ 'company.PaymentActionCssFieldLabel' | translate }}</label>
                        <textarea class="form-control" name="PaymentActionPageCss" #PaymentActionPageCss="ngModel"
                                  [(ngModel)]="currentPageStyle.PaymentActionPageCss"
                                  placeholder="{{'company.PaymentActionCssFieldPlaceHolder' | translate}}"
                                  rows="5"></textarea>
                      </div>

                      <div *ngIf="currentObject.CompanyId">

                        <!-- Logo Image -->
                        <div class="form-group">
                          <label class="image-label"
                                 for="LogoImageFileName">{{ 'company.logoImageFieldLabel' | translate }}</label>
                          <div class="image-field-row">
                            <input id="LogoImageFileNameField" class="form-control" name="LogoImageFileName"
                                 #LogoImageFileName="ngModel"
                                 [(ngModel)]="currentPageStyle.LogoImageFileName"
                                 placeholder="{{'company.logoImageFieldPlaceHolder' | translate}}" readonly>
                          <input type="file" id="UploadLogoImageFile" class="form-control" #logoImageInput
                                 (change)="saveLogoImage($event.target.files)"
                                 readonly hidden>
                          <button id="UploadLogoImageButton" type="button"
                                  class="btn btn-primary btn-raised image-action-button"
                                  title="{{ 'company.uploadLogoImageTitle' | translate }}"
                                  [attr.aria-label]="'company.uploadLogoImageTitle' | translate"
                                  [disabled]="imageRequestInFlight"
                                  (click)="logoImageInput.click()">
                            <i class="ft-upload" aria-hidden="true"></i>
                          </button>
                          <!-- An anchor, so a middle click opens the image the way any other link would. -->
                          <a id="CopyLogoImageUrlLink"
                             class="btn btn-primary btn-raised image-action-button"
                             [class.image-action-button-inert]="!logoImageUrl"
                             [attr.href]="logoImageUrl" rel="noopener"
                             [attr.tabindex]="logoImageUrl ? null : -1"
                             title="{{ 'company.copyLogoImageUrlTitle' | translate }}"
                             [attr.aria-label]="'company.copyLogoImageUrlTitle' | translate"
                             (click)="copyLogoImageUrl($event)">
                            <i class="ft-copy" aria-hidden="true"></i>
                          </a>
                          <button id="DeleteLogoImageButton" type="button"
                                  class="btn btn-danger btn-raised image-action-button"
                                  title="{{ 'company.deleteLogoImageTitle' | translate }}"
                                  [attr.aria-label]="'company.deleteLogoImageTitle' | translate"
                                  [disabled]="!currentPageStyle.LogoImageFileName || imageRequestInFlight"
                                  (click)="deleteLogoImage()">
                            <i class="ft-trash-2" aria-hidden="true"></i>
                          </button>
                          </div>
                        </div>

                        <!-- Background Image -->
                        <div class="form-group">
                          <label class="image-label"
                                 for="BackgroundImageFileName">{{ 'company.backgroundImageFieldLabel' | translate }}</label>
                          <div class="image-field-row">
                            <input id="BackgroundImageFileNameField" class="form-control" name="BackgroundImageFileName"
                                 #BackgroundImageFileName="ngModel"
                                 [(ngModel)]="currentPageStyle.BackgroundImageFileName"
                                 placeholder="{{'company.backgroundImageFieldPlaceHolder' | translate}}" readonly>
                          <input type="file" id="UploadBackgroundImageFile" class="form-control" #backgroundImageInput
                                 (change)="saveBackgroundImage($event.target.files)"
                                 readonly hidden>
                          <button id="UploadBackgroundImageButton" type="button"
                                  class="btn btn-primary btn-raised image-action-button"
                                  title="{{ 'company.uploadBackgroundImageTitle' | translate }}"
                                  [attr.aria-label]="'company.uploadBackgroundImageTitle' | translate"
                                  [disabled]="imageRequestInFlight"
                                  (click)="backgroundImageInput.click()">
                            <i class="ft-upload" aria-hidden="true"></i>
                          </button>
                          <!-- An anchor, so a middle click opens the image the way any other link would. -->
                          <a id="CopyBackgroundImageUrlLink"
                             class="btn btn-primary btn-raised image-action-button"
                             [class.image-action-button-inert]="!backgroundImageUrl"
                             [attr.href]="backgroundImageUrl" rel="noopener"
                             [attr.tabindex]="backgroundImageUrl ? null : -1"
                             title="{{ 'company.copyBackgroundImageUrlTitle' | translate }}"
                             [attr.aria-label]="'company.copyBackgroundImageUrlTitle' | translate"
                             (click)="copyBackgroundImageUrl($event)">
                            <i class="ft-copy" aria-hidden="true"></i>
                          </a>
                          <button id="DeleteBackgroundImageButton" type="button"
                                  class="btn btn-danger btn-raised image-action-button"
                                  title="{{ 'company.deleteBackgroundImageTitle' | translate }}"
                                  [attr.aria-label]="'company.deleteBackgroundImageTitle' | translate"
                                  [disabled]="!currentPageStyle.BackgroundImageFileName || imageRequestInFlight"
                                  (click)="deleteBackgroundImage()">
                            <i class="ft-trash-2" aria-hidden="true"></i>
                          </button>
                          </div>
                        </div>

                        <!-- The public image URLs embed the company slug, so they cannot be built without one. -->
                        <div class="form-group" *ngIf="!hasSlugForImageUrls">
                          <small class="text-muted">{{ 'company.imageUrlRequiresSlugMessage' | translate }}</small>
                        </div>
                      </div>
                    </div>
                    <!-- Payment Link Provider -->
                    <div class="form-group">
                      <h4 class="form-section">
                        <i class="ft-edit"></i> {{ 'company.paymentLinkProvider.header' | translate }}
                      </h4>

                      <!-- Platform Provider -->
                      <div class="form-group">
                        <label>{{ 'company.paymentLinkProvider.provider.header' | translate }}</label>

                        <!-- Provider: IbanXS -->
                        <div class="form-check">
                          <input type="radio" class="form-check-input" id="PaymentLinkProviderIbanXS"
                                 [value]="false" name="PaymentLinkProvider"
                                 [(ngModel)]="currentObject.UseMolliePaymentLinkProvider">
                          <label class="form-check-label"
                                 for="PaymentLinkProviderIbanXS">{{ 'company.paymentLinkProvider.provider.ibanXS.fieldLabel' | translate }}</label>
                        </div>
                        <!-- Provider: Mollie -->
                        <div class="form-check">
                          <input type="radio" class="form-check-input" id="PaymentLinkProviderMollie"
                                 [value]="true" name="PaymentLinkProvider"
                                 [(ngModel)]="currentObject.UseMolliePaymentLinkProvider">
                          <label class="form-check-label"
                                 for="PaymentLinkProviderMollie">{{ 'company.paymentLinkProvider.provider.mollie.fieldLabel' | translate }}</label>
                        </div>

                        <!-- Mollie Profile Api Key -->
                        <div class="form-group"
                             *ngIf="currentObject.UseMolliePaymentLinkProvider === true">
                          <label
                            for="PaymentLinkProviderAPIKey">{{ 'company.paymentLinkProvider.provider.apiKeyFieldLabel' | translate }}</label>
                          <div class="input-group">
                            <input type="{{showPaymentLinkProviderMollieApiKey? 'text' : 'password' }}"
                                   class="form-control" name="PaymentLinkProviderAPIKey" id="PaymentLinkProviderAPIKey"
                                   [(ngModel)]="currentObject.MollieProfileApiKey"
                                   placeholder="{{'company.paymentLinkProvider.provider.apiKeyFieldLabel' | translate}}">
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <a data-original-title="" title="toggle"
                                   (click)="showPaymentLinkProviderMollieApiKey = !showPaymentLinkProviderMollieApiKey">
                                  <i [ngClass]="showPaymentLinkProviderMollieApiKey? 'ft-eye-off' : 'ft-eye'"></i>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>

                        <div class="form-group"
                             *ngIf="currentObject.UseMolliePaymentLinkProvider === false">
                          <label>IbanXS betaalverzoek UI</label>
                          <div class="form-check">
                            <input type="radio" class="form-check-input" id="IbanXSPaymentRequestUiModeIbanXSHosted"
                                   [value]="IbanXSPaymentRequestUiMode.IbanXSHosted" name="IbanXSPaymentRequestUiMode"
                                   [(ngModel)]="currentObject.IbanXSPaymentRequestUiMode">
                            <label class="form-check-label" for="IbanXSPaymentRequestUiModeIbanXSHosted">
                              IbanXS hosted
                            </label>
                          </div>
                          <div class="form-check">
                            <input type="radio" class="form-check-input" id="IbanXSPaymentRequestUiModeAIHubHosted"
                                   [value]="IbanXSPaymentRequestUiMode.AIHubHosted" name="IbanXSPaymentRequestUiMode"
                                   [(ngModel)]="currentObject.IbanXSPaymentRequestUiMode">
                            <label class="form-check-label" for="IbanXSPaymentRequestUiModeAIHubHosted">
                              AI-Hub hosted
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Signhost -->
                    <div class="form-group">
                      <h4 class="form-section">
                        <i class="ft-edit"></i> {{ 'company.signhost.header' | translate }}
                      </h4>

                      <!-- Platform Provider -->
                      <div class="form-group">
                        <label>{{ 'company.signhost.provider.header' | translate }}</label>

                        <!-- Provider: Nidaros -->
                        <div class="form-check">
                          <input type="radio" class="form-check-input" id="SignhostProviderNidaros"
                                 [value]="SignhostProvider.Nidaros" name="SignhostPlatformProvider"
                                 [(ngModel)]="currentObject.SignhostPlatformProvider">
                          <label class="form-check-label"
                                 for="SignhostProviderNidaros">{{ 'company.signhost.provider.nidaros.fieldLabel' | translate }}</label>
                        </div>
                        <!-- Provider: Extern -->
                        <div class="form-check">
                          <input type="radio" class="form-check-input" id="SignhostProviderExtern"
                                 [value]="SignhostProvider.Extern" name="SignhostPlatformProvider"
                                 [(ngModel)]="currentObject.SignhostPlatformProvider">
                          <label class="form-check-label"
                                 for="SignhostProviderExtern">{{ 'company.signhost.provider.external.fieldLabel' | translate }}</label>
                        </div>

                        <!-- Signhost Api Key -->
                        <div class="form-group"
                             *ngIf="currentObject.SignhostPlatformProvider === SignhostProvider.Extern">
                          <label
                            for="SignhostProviderAPIKey">{{ 'company.signhost.provider.apiKeyFieldLabel' | translate }}</label>
                          <div class="input-group">
                            <input type="{{showSignhostApiKey? 'text' : 'password' }}"
                                   class="form-control" name="SignhostProviderAPIKey" id="SignhostProviderAPIKey"
                                   [(ngModel)]="currentObject.SignhostProviderAPIKey"
                                   placeholder="{{'company.signhost.provider.apiKeyFieldLabel' | translate}}">
                            <div class="input-group-append">
                              <span class="input-group-text">
                                <a data-original-title="" title="toggle"
                                   (click)="showSignhostApiKey = !showSignhostApiKey">
                                  <i [ngClass]="showSignhostApiKey? 'ft-eye-off' : 'ft-eye'"></i>
                                </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </ng-template>
              </li>

              <!-- Company Banks -->
              <li
                *ngIf="hasCompanyBanksConsentViewPermission && currentObject.CompanyId && currentObject.IsSuccessfullyOnboarded"
                ngbNavItem>
                <a #companyBanksLink ngbNavLink><i
                  class="icon-credit-card"></i> {{ 'company.companyBanksTitle' | translate }} </a>
                <ng-template ngbNavContent>
                  <app-company-banks [(company)]="currentObject"></app-company-banks>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav"></div>

            <div class="form-actions">
              <button [hidden]="!hasCompanyDetailsViewPermission" class="btn btn-raised btn-raised btn-warning mr-1"
                      type="button" (click)="resetForm(companyForm)">
                <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
              </button>
              <button [hidden]="!hasCompanyDetailsViewPermission" [disabled]="!companyForm.valid"
                      class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
                <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
              </button>
              <button type="button" class="btn btn-secondary btn-raised mr-1" (click)="closeModal()">
                <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
